import { Dialog } from "@mui/material";
import { ModalCloseButton } from "../../../../Components/Molecules/ValutDialog";
import { formatPixKeyValue, getPixKeyTypeMeta } from "./constants";

export const PixKeyDeleteModal = ({
  open,
  keyItem,
  onClose,
  onConfirm,
  submitting = false,
}) => {
  if (!keyItem) return null;

  const typeMeta = getPixKeyTypeMeta(keyItem.type);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ className: "!rounded-2xl !shadow-card" }}
    >
      <div className="relative px-5 py-6 sm:px-6">
        <ModalCloseButton onClick={onClose} className="absolute right-3 top-3" disabled={submitting} />
        <h2 className="pr-8 text-lg font-bold text-brand-dark">Excluir chave Pix?</h2>
        <p className="mt-2 text-sm text-gray-500">
          Esta chave deixará de receber pagamentos. Você poderá cadastrá-la novamente depois, se desejar.
        </p>

        <div className="mt-4 rounded-xl border border-gray-100 bg-gray-50 px-4 py-3">
          <p className="text-xs font-medium uppercase tracking-wide text-gray-400">
            {typeMeta?.label || "Chave Pix"}
          </p>
          <p className="mt-1 text-sm font-semibold text-brand-dark">
            {formatPixKeyValue(keyItem.type, keyItem.value)}
          </p>
        </div>

        <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            className="inline-flex h-9 min-h-9 items-center justify-center rounded-lg border border-red-200 bg-red-50 px-5 text-sm font-semibold text-red-600 transition hover:bg-red-100"
            onClick={onConfirm}
            disabled={submitting}
          >
            {submitting ? "Excluindo..." : "Excluir chave"}
          </button>
        </div>
      </div>
    </Dialog>
  );
};
